<script setup lang="ts">
const { menu, getNavItems } = useNav()
</script>

<template>
  <nav class="bg-icsgray-50 min-h-full dark:bg-icsnight-800">
    <BlockContent class="space-y-4">
      <ul class="gap-y-5 grid grid-cols-1 f-gap-x-32-48 lg:grid-cols-3 sm:grid-cols-2">
        <li
          v-for="item in menu"
          :key="item.name"
        >
          <NuxtLink
            :to="item.to"
            class="group text-xl heading-link-bright focusable inline-flex h-11 uppercase items-center justify-between font-flex-440-151-600"
          >
            {{ item.title || item.name }}
          </NuxtLink>
          <div
            v-if="item.children"
            class="space-y-4"
          >
            <hr class="b-icssilver dark:b-icsjet">
            <ANav :menu="getNavItems(item.children)">
              <template #default="{ item: subitem }">
                <NuxtLink
                  class="heading-link-gray focusable flex text-truncate transition items-center f-py-4-8 font-flex-400-120 @hover:heading-link-hover media-[(pointer:coarse)]:min-h-11"
                  :to="subitem.to"
                  :exact-active-class="item.name === 'industries' ? '' : 'heading-link-active'"
                >
                  <div class="i-carbon-chevron-right mr-1 size-4" />{{ subitem.label || subitem.title || subitem.name }} <div
                    v-if="subitem.exit"
                    class="i-carbon-launch ml-1.5 size-4.5 -translate-y-px"
                  />
                </NuxtLink>
              </template>
            </ANav>
          </div>
        </li>
      </ul>
      <hr class="b-icssilver dark:b-icsjet">
      <ButtonThemeToggle
        color="gray"
        size="small"
      />
    </BlockContent>
  </nav>
</template>
